module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_13-cc2a79321add27edaab35355dab526ef.jpg";